/** Serializes an error to JSON.
 *  @param error The error to serialize.
*/
export default function serializeError(error) {
    return JSON.stringify(Object.assign({}, error));
}
